import { ModalService } from 'src/app/services/modal.service';
import { SegmentVO } from '../../../../../data/vo/SegmentVO';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { CampaignAdapter } from '../../../../../../adapters/campaign-adapter';
import { GenderConst } from '../../constants/Gender.const';
import { NameValuePairVO } from '../../../../../data/vo/NameValuePairVO';
import { CampaignVO } from 'src/app/data/vo/CampaignVO';
import { Subscription } from 'rxjs';
import { CampaignService } from '../../services/campaign.service';
import { IOptionProps } from '@amobee/component-library';

@Component({
    selector: 'audience',
    templateUrl: './audience.component.html',
    styleUrls: ['./audience.component.scss']
})
export class AudienceComponent implements OnInit {

    @Input() group: FormGroup;
    @Input() isNew: boolean;
    @Input() campaignVO: CampaignVO;
    @Input() segments: Array<SegmentVO>;
    @Input() isReadOnly: boolean;

    genderConst = GenderConst;
    audienceSize: number;
    defaultLanguage: string = 'English';
    // this will be true in edit mode
    isLCGChangedByUser: boolean = false;
    genres: NameValuePairVO[] = [];
    languages: NameValuePairVO[] = [];
    channels: NameValuePairVO[] = [];
    channelValues: string[] = [];
    filteredLanguages: NameValuePairVO[] = [];
    filteredChannels: NameValuePairVO[] = [];
    filteredGenres: NameValuePairVO[] = [];
    languageSubscription: Subscription;
    channelSubscription: Subscription;
    startDateSubscription: Subscription;
    endDateSubscription: Subscription;
    segmentSubscription: Subscription;
    genderSubscription: Subscription;
    ageSubscription: Subscription;
    suggestedCampaignSubscription: Subscription;
    selectedSuggestedCampaignVO: CampaignVO;

    ageRanges: any = {
        'A': ['15+', '15-24', '15-34', '18+', '25-34', '25-44', '55+'],
        'F': ['15+', '15-24', '15-34', '18+', '25-34', '25-44', '55+'],
        'M': ['15+', '15-24', '15-34', '18+', '25-34', '25-44', '55+']
    };
    campaignId: number;
    refreshingAttributes: boolean = false;
    selectedSegment: SegmentVO = new SegmentVO('', '');
    segmentFormControl = new FormControl();
    ageFormControl = new FormControl();
    updateFromSegmentChange: boolean = false;

    constructor(
        private campaignAdapter: CampaignAdapter,
        private modal: ModalService,
        private campaignService: CampaignService
    ) {
    }

    ngOnInit() {
        this.campaignId = this.campaignVO.id;
        if (!this.isNew) {
            if (this.campaignVO.channels && this.campaignVO.channels.length) {
                this.channelControl.patchValue(this.campaignVO.channels, { emitEvent: false });
            }

            if (this.campaignVO.genres && this.campaignVO.genres.length) {
                this.genreControl.patchValue(this.campaignVO.genres, { emitEvent: false });
            }

            if (this.campaignVO.languages && this.campaignVO.languages.length) {
                this.languageControl.patchValue(this.campaignVO.languages, { emitEvent: false });
            }
            this.isLCGChangedByUser = true;
        }

        this.campaignAdapter.getTotalAudienceSize(this.campaignId).then(totalAudienceSize => {
            this.campaignVO.totalAudienceSize = totalAudienceSize;
        });

        this.audienceSizeRefresh();

        if (this.group.disabled || this.isReadOnly) {
            this.segmentFormControl.disable();
            this.ageFormControl.disable();
        }

        if (this.ageControl.disabled) {
            this.ageFormControl.disable();
        }

        // getting full list of LCG, these should be called once when component loads
        this.campaignAdapter.getChannels().then((channels: NameValuePairVO[]) => {
            this.channels = channels;
            this.channelValues = channels.map(v => v.value);
        });

        this.campaignAdapter.getGenre().then((genres: NameValuePairVO[]) => {
            this.genres = genres;
        });

        this.campaignAdapter.getLanguages().then((languages: NameValuePairVO[]) => {
            this.languages = languages;
        });

        // getting filtered list of LCG based on flight date and exsiting settings if there are
        this.campaignAdapter.getLanguages(this.startDate, this.endDate).then((languages: NameValuePairVO[]) => {
            this.filteredLanguages = languages;
            if (this.isNew) {
                // emiting event so that channels and genres will be handled in the subscription callback
                this.languageControl.patchValue(languages.filter(v => v.name.toUpperCase() === this.defaultLanguage.toUpperCase()).map(v => v.value));
            } else {
                this.refreshAttributeOptions("language", this.languageControl.value, false);
            }
        });

        this.campaignAdapter.getGenderAgeMapping().then(genderAge => {
            this.ageRanges = genderAge;
        });

        this.languageSubscription = this.languageControl.valueChanges.subscribe((languages) => {
            this.refreshAttributeOptions("language", languages);
            this.resetPreBuiltCampaignOnAudienceTargetingChange();
        });

        this.channelSubscription = this.channelControl.valueChanges.subscribe((channels) => {
            //need to also set excludeChannels
            this.excludeChannelControl.setValue(this.channelValues.filter(c => !channels.includes(c)));
            this.refreshAttributeOptions("channel", channels);
            this.resetPreBuiltCampaignOnAudienceTargetingChange();
        });

        this.startDateSubscription = this.startDateControl.valueChanges.subscribe(() => {
            this.refreshAttributeOptions("Date");
        });

        this.endDateSubscription = this.endDateControl.valueChanges.subscribe(() => {
            this.refreshAttributeOptions("Date");
        });

        this.segmentSubscription = this.segmentControl.valueChanges.subscribe((newVal) => {
            if (newVal && newVal.value !== this.selectedSegment.value) {
                this.selectedSegment = _.find(this.segments, segment => segment.value === newVal.value);
                this.segmentFormControl.setValue({ label: this.selectedSegment.name, value: this.selectedSegment.value });
                this.ageFormControl.setValue({ value: this.selectedSegment.age });
                this.ageControl.setValue(this.selectedSegment.age, { emitEvent: false });
                this.genderControl.setValue(this.selectedSegment.gender, { emitEvent: false });
            }
            this.audienceSizeRefresh();
        });

        this.genderSubscription = this.genderControl.valueChanges.subscribe((value) => {
            if (value !== this.selectedSegment.gender && this.segmentFormControl.value) {
                this.resetSegmentValue();
                this.resetPreBuiltCampaignOnAudienceTargetingChange();
            }
            this.audienceSizeRefresh();
        });

        this.ageSubscription = this.ageControl.valueChanges.subscribe(() => {
            !this.updateFromSegmentChange && this.audienceSizeRefresh();
        });

        this.suggestedCampaignSubscription = this.campaignService.getSuggestedCampaignUpdated().subscribe((cvo: CampaignVO) => {
            this.selectedSuggestedCampaignVO = _.cloneDeep(cvo);
            if (cvo && !_.isEmpty(cvo.channels)) {
                // if there is template selected, need a way to reset language to English
                this.languageControl.patchValue(this.languages.filter(v => v.name.toUpperCase() === this.defaultLanguage.toUpperCase()).map(v => v.value), { emitEvent: false });
                this.campaignAdapter.getChannels(this.startDate, this.endDate, this.languageValue).then((channels: NameValuePairVO[]) => {
                    this.filteredChannels = channels;
                });
            }
        });

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.segments && !_.isEmpty(changes.segments.currentValue) && this.segmentControl.value && !this.isNew) {
            for (let segment of this.segments) {
                if (segment.value === this.segmentValue.value) {
                    this.selectedSegment = segment;
                    this.segmentFormControl.patchValue({ label: segment.name, value: segment.value });
                    break;
                }
            }
        }
    }

    segmentChange(event: IOptionProps) {
        if (this.selectedSuggestedCampaignVO) {
            this.campaignService.resetSuggestedCampaign(() => {
                this.selectSegment(event.value);
            }, () => {
                if (this.segmentValue) {
                    this.segmentFormControl.patchValue({ label: this.segmentValue.name, value: this.segmentValue.value });
                }
            });
        } else {
            this.selectSegment(event.value);
        }
    }

    selectSegment(value: string) {
        this.updateFromSegmentChange = true;
        if (!value) {
            // On selecting "Select a segment" option.
            this.segmentControl.patchValue(null);
            //rest age gender to default
            this.ageFormControl.setValue({ value: '15+' });
            this.ageControl.setValue('15+', { emitEvent: false });
            this.genderControl.setValue('A', { emitEvent: false });
        } else {
            for (let segment of this.segments) {
                if (segment.value === value) {
                    this.selectedSegment = segment;
                    let segmentAsNameValuePair = {
                        name: segment.name,
                        value: segment.value
                    }
                    this.ageFormControl.setValue({ value: segment.age });
                    this.ageControl.setValue(segment.age, { emitEvent: false });
                    this.genderControl.setValue(segment.gender, { emitEvent: false });
                    this.segmentControl.setValue(segmentAsNameValuePair);
                    break;
                }
            }
        }
        this.updateFromSegmentChange = false;
    }

    audienceSizeRefresh() {
        this.campaignAdapter.getTargetedAudienceSize(this.campaignId,
            this.segmentControl.value === 'undefined' ? null : this.segmentControl.value,
            this.genderControl.value,
            this.ageControl.value === 'undefined' ? null : this.ageControl.value)
            .then(targetedAudienceSize => {
                this.campaignVO.audienceSize = this.audienceSize = targetedAudienceSize;
            });
    }


    updateAttributeVO(value: NameValuePairVO, isCheck: boolean, controlValue: Array<any>, control: FormControl) {
        let values = controlValue;
        const index = _.findIndex(values, (val) => val === value.value);
        if (isCheck && index === -1) {
            values.push(value.value);
            control.patchValue(values);
            control.markAsTouched();
            this.isLCGChangedByUser = true;
        } else if (!isCheck && index > -1) {
            values.splice(index, 1);
            control.patchValue(values);
            control.markAsTouched();
            this.isLCGChangedByUser = true;
        }
    }

    onAttributeToggle(e: any, attribute: NameValuePairVO, type: string) {
        // TODO: wait for component library to update the toggle method to support label
        if (_.isBoolean(e) && attribute) {
            let controls, controlValue;
            switch (type) {
                case 'language':
                    controlValue = this.languageValue;
                    controls = this.languageControl;
                    break;
                case 'channel':
                    controlValue = this.channelValue;
                    controls = this.channelControl;
                    break;
                case 'genre':
                    controlValue = this.genreValue;
                    controls = this.genreControl;
                    break;
            }
            this.updateAttributeVO(attribute, e, controlValue, controls);
        }
    }

    refreshAttributeOptions(changedType: string, values?: Array<any>, patchControl: boolean = true) {
        this.refreshingAttributes = true;
        if (changedType === 'language') {
            this.campaignAdapter.getChannels(this.startDate, this.endDate, values).then((channels: NameValuePairVO[]) => {
                this.filteredChannels = channels;
                if (patchControl) {
                    this.channelControl.patchValue(channels.map(v => v.value), { emitEvent: false });
                }
                this.campaignAdapter.getGenre(this.startDate, this.endDate, values, this.channelValue).then((genres: NameValuePairVO[]) => {
                    this.filteredGenres = genres;
                    if (patchControl) {
                        this.genreControl.patchValue(genres.map(v => v.value));
                    }
                    this.refreshingAttributes = false;
                });
            });
        } else if (changedType === 'channel') {
            this.campaignAdapter.getGenre(this.startDate, this.endDate, this.languageValue, values).then((genres: NameValuePairVO[]) => {
                this.filteredGenres = genres;
                if (patchControl) {
                    this.genreControl.patchValue(genres.map(v => v.value));
                }
                this.refreshingAttributes = false;
            });
        } else if (changedType === 'Date') {
            if (this.isLCGChangedByUser && !this.selectedSuggestedCampaignVO) {
                this.modal.info({ message: 'Your language, channel, and genre selections will be reset by your start/end date change' });
            }
            this.campaignAdapter.getLanguages(this.startDate, this.endDate).then((languages: NameValuePairVO[]) => {
                this.filteredLanguages = languages;
                if (this.selectedSuggestedCampaignVO) {
                    // if there is selected template, we need to retain current channels
                    this.campaignAdapter.getChannels(this.startDate, this.endDate, this.languageValue).then((channels: NameValuePairVO[]) => {
                        this.filteredChannels = channels;
                        this.channelControl.patchValue(_.intersection(this.selectedSuggestedCampaignVO.channels, channels.map(v => v.value)), { emitEvent: false });
                        this.refreshAttributeOptions("channel", this.channelValue);
                    });
                } else {
                    this.languageControl.patchValue(languages.filter(v => v.name.toUpperCase() === this.defaultLanguage.toUpperCase()).map(v => v.value));
                }
            });
        } else {
            this.refreshingAttributes = false;
        }

    }

    isAttributeDisabled(attribute: NameValuePairVO, type: string) {
        let filteredValues = [];
        switch (type) {
            case 'language':
                filteredValues = this.filteredLanguages;
                break;
            case 'channel':
                filteredValues = this.filteredChannels;
                break;
            case 'genre':
                filteredValues = this.filteredGenres;
                break;
        }
        return filteredValues.findIndex(val => val.value === attribute.value) === -1;
    }

    ageChange(event: IOptionProps) {
        if (event.value) {
            if (event.value !== this.selectedSegment.age && this.segmentFormControl.value) {
                this.resetSegmentValue();
                this.resetPreBuiltCampaignOnAudienceTargetingChange();
            }
            this.ageControl.setValue(event.value);
        }
    }

    resetSegmentValue(): void {
        if (!this.selectedSuggestedCampaignVO) {
            this.modal.info({ message: 'Your segment selection has been reset by your age/gender change' });
        }
        this.segmentControl.setValue(null, { emitEvent: false });
        this.segmentFormControl.setValue(null);
        this.selectedSegment = new SegmentVO('', '');
    }

    resetPreBuiltCampaignOnAudienceTargetingChange(): void {
        if (this.selectedSuggestedCampaignVO) {
            this.campaignService.resetSuggestedCampaign(undefined, () => {
                this.onModalCancel();
            });
        }
    }

    onModalCancel() {
        this.segmentControl.patchValue(this.selectedSuggestedCampaignVO.segment);
        this.languageControl.patchValue(this.languages.filter(v => v.name.toUpperCase() === this.defaultLanguage.toUpperCase()).map(v => v.value)
            , { emitEvent: false });
        this.channelControl.patchValue([].concat(this.selectedSuggestedCampaignVO.channels), { emitEvent: false });
        this.refreshAttributeOptions("channel", this.selectedSuggestedCampaignVO.channels);
    }

    ngOnDestroy(): void {
        if (this.languageSubscription) {
            this.languageSubscription.unsubscribe();
        }
        if (this.channelSubscription) {
            this.channelSubscription.unsubscribe();
        }
        if (this.startDateSubscription) {
            this.startDateSubscription.unsubscribe();
        }
        if (this.endDateSubscription) {
            this.endDateSubscription.unsubscribe();
        }
        if (this.segmentSubscription) {
            this.segmentSubscription.unsubscribe();
        }
        if (this.genderSubscription) {
            this.genderSubscription.unsubscribe();
        }
        if (this.ageSubscription) {
            this.ageSubscription.unsubscribe();
        }
        if (this.suggestedCampaignSubscription) {
            this.suggestedCampaignSubscription.unsubscribe();
        }
    }

    get genderControl(): FormControl {
        return this.group.get('gender') as FormControl;
    }

    get ageControl(): FormControl {
        return this.group.get('age') as FormControl;
    }

    get languageControl(): FormControl {
        return this.group.get('languages') as FormControl;
    }

    get languageValue(): Array<any> {
        return this.languageControl.value;
    }

    get channelControl(): FormControl {
        return this.group.get('channels') as FormControl;
    }

    get channelValue(): Array<any> {
        return this.channelControl.value;
    }

    get excludeChannelControl(): FormControl {
        return this.group.get('excludeChannels') as FormControl;
    }

    get genreControl(): FormControl {
        return this.group.get('genres') as FormControl;
    }

    get genreValue(): Array<any> {
        return this.genreControl.value;
    }

    get segmentControl(): FormControl {
        return this.group.get('segment') as FormControl;
    }

    get segmentValue(): NameValuePairVO {
        return this.segmentControl.value;
    }

    get startDateControl(): FormControl {
        return this.group.get('startDate') as FormControl;
    }

    get endDateControl(): FormControl {
        return this.group.get('endDate') as FormControl;
    }

    get startDate(): number {
        return this.startDateControl.value;
    }

    get endDate(): number {
        return this.endDateControl.value;
    }

    get isDisabled(): boolean {
        return this.group.disabled;
    }
}
